<template>
  <div class="control-group"
        :class="{
          'invalid': input_invalids && input_invalids[input_name],
          'disabled': input_disabled
        }">
      <div class="control check-group" :class="{'required': input_required}">
          <input
              type="checkbox"
              :id="input_id"
              :required="input_required"
              :checked="input_value"
              :disabled="input_disabled"
              :true-value="true_value"
              :false-value="false_value"
              @change="onChangeValue"
          >
          <label
            :for="input_id">{{ Language.say(label_text) }}
          </label>
      </div>
      <p class="error" v-if="input_invalids && input_invalids[input_name]">
        {{ Language.say(error_text) }}
      </p>
  </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';
  import Language                   from '@/js/Shared/Language/Language';

  const props = defineProps({
    input_id: {
      type: String,
      default: '',
    },
    input_name: {
      type: String,
      required: true,
    },
    input_required: {
      type: Boolean,
      default: false
    },
    input_disabled: {
      type: Boolean,
      default: false
    },
    input_invalids: {
      type: Object,
      default : {},
    },
    input_value: {
      type: [Boolean, String, Number],
      default: false
    },
    label_text: {
      type: String,
      default: ''
    },
    error_text: {
      type: String,
      default: 'global.forms.invalid.input'
    },
    true_value: {
      type: [Boolean, Number, String],
      default: true
    },
    false_value: {
      type: [Boolean, Number, String],
      default: false
    },
  });

  const emit = defineEmits(['change', 'update:input_value']);

  const onChangeValue = ($event) => {
    const value = $event.target.checked ? props.true_value : props.false_value;
    emit('change', value);
    emit('update:input_value', value);
  }
</script>